
// Firestore collection names
export const DB_NAME = null
export const PORTFOLIOS_COLLECTION = 'portfolios';
export const USERS_COLLECTION = 'users';
export const LEADS_COLLECTION = 'leads';
export const INVITATIONS_COLLECTION = 'invitations';
export const METADATA_DOCUMENT = 'metadata';
export const BUSINESS_COLLECTION = 'businesses'; // Added missing constant

// Common field names
export const CREATED_AT = 'createdAt';
export const UPDATED_AT = 'updatedAt';
export const MEMBERS_FIELD = 'members';
export const STATUS_FIELD = 'status';
